/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import {
  Col,
  Row,
  Form,
  Select,
  Input,
  DatePicker,
  Button,
  Checkbox,
  Tooltip,
  Card,
} from "antd";
import { v4 as uuidv4 } from "uuid";
import Notes from "../../../../../components/common/Notes";
import AttachmentsUpload from "../../../../../components/common/AttachmentsUpload";

const OtherReceipt = () => {
  const toolTipText = (
    <p style={{ color: "#000" }}>
      Checking this box will exclude this receipt from the Pay Management Fees
      calculation. Use this when an additional fee was collected, then waived or
      refunded, and you are refunding the balance with an Other Receipt
    </p>
  );

  const initialList = [{ id: uuidv4() }];

  const [accounts, setAccounts] = useState(initialList);

  function handleAddAccount() {
    const newList = accounts.concat({ id: uuidv4() });
    setAccounts(newList);
  }

  function handleRemoveAccount(id) {
    const newList = accounts.filter((item) => item.id !== id);
    setAccounts(newList);
  }
  return (
    <div className="OtherReceipt">
      <div className="pageheading">
        <h1>New Other Receipt</h1>
        <div className="pageHeadingBtns">
          <button>Repeat Receipt</button>
        </div>
      </div>

      <Form autoComplete="off" layout="vertical">
        <Card>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Received From" name="receivedForm" required>
                <Input />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label="Receipt Date" name="receiptDate" required>
                <DatePicker style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                label="Posting Date"
                name="postingDate"
                required
                autoComplete="off"
              >
                <DatePicker style={{ width: "100%" }} />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Form.Item name="remember" valuePropName="checked">
                <Checkbox>
                  {" "}
                  Exclude from pay management fees calculation{" "}
                  <Tooltip
                    placement="top"
                    title={toolTipText}
                    trigger={["click"]}
                    color={["#fff"]}
                  >
                    <i
                      className="fa-solid fa-circle-question"
                      style={{ color: "#3179cd" }}
                    ></i>
                  </Tooltip>
                </Checkbox>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Property" name="property" required>
                <Select
                  showSearch
                  placeholder="Start typing to search"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={[
                    {
                      value: "jack",
                      label: "Jack",
                    },
                    {
                      value: "lucy",
                      label: "Lucy",
                    },
                    {
                      value: "tom",
                      label: "Tom",
                    },
                  ]}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Unit" name="Unit">
                <Select
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={[
                    {
                      value: "jack",
                      label: "Jack",
                    },
                    {
                      value: "lucy",
                      label: "Lucy",
                    },
                    {
                      value: "tom",
                      label: "Tom",
                    },
                  ]}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Reference" name="reference">
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Remarks" name="remarks">
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Form.Item label="Cash Account" name="CashAccount">
                <Select
                  showSearch
                  placeholder="Automatic"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={[
                    {
                      value: "jack",
                      label: "Jack",
                    },
                    {
                      value: "lucy",
                      label: "Lucy",
                    },
                    {
                      value: "tom",
                      label: "Tom",
                    },
                  ]}
                />
              </Form.Item>
            </Col>
          </Row>

          <ul>
            <Row style={{ marginBottom: 12 }}>
              <Col className="tableHead" span={9}>
                <p>GL Account</p>
              </Col>
              <Col className="tableHead" span={9}>
                <p>Description</p>
              </Col>
              <Col className="tableHead" span={5}>
                <p>Amount</p>
              </Col>
              <Col span={1}></Col>
            </Row>
            {accounts.map((item) => (
              <li key={item.id}>
                <Form.Item label="">
                  <Row>
                    <Col span={9}>
                      <Select
                        showSearch
                        placeholder="Start typing to search"
                        style={{ width: "100%" }}
                      />
                    </Col>
                    <Col span={9}>
                      <Input />
                    </Col>
                    <Col span={5}>
                      <Input type="Number" prefix="$" />
                    </Col>
                    <Col span={1}>
                      {accounts.length > 1 ? (
                        <Button
                          className="roundSmallButton"
                          onClick={() => {
                            handleRemoveAccount(item.id);
                          }}
                          type="primary"
                          shape="circle"
                          icon={<i className="fa-sharp fa-solid fa-xmark"></i>}
                          size={"small"}
                        />
                      ) : (
                        <></>
                      )}
                    </Col>
                  </Row>
                </Form.Item>
              </li>
            ))}

            <Form.Item label="">
              <Button
                className="addPropertyGroupButton"
                type="primary"
                onClick={handleAddAccount}
                size={"small"}
                icon={<i className="fa-solid fa-circle-plus"></i>}
              >
                {" "}
                Add Another Line
              </Button>
            </Form.Item>

            <Row>
              <Col span={18}></Col>
              <Col span={4}>
                <h4>Total: </h4>
              </Col>
              <Col span={2}>
                <h4>$ {"0.00"} </h4>
              </Col>
            </Row>
          </ul>
          <Row gutter={16}>
            <Col>
              <Button type="primary">Save & Add Another</Button>
            </Col>
            <Col>
              <Button>Save</Button>
            </Col>
            <Col>
              <Button type="link">Cancel</Button>
            </Col>
          </Row>
        </Card>
        <br />

        <Row gutter={[0, 24]}>
          <Col span={24}>
            {/* <Notes /> */}
          </Col>
          <Col span={24}>
            {/* <AttachmentsUpload /> */}
          </Col>
        </Row>
      </Form>
      <div className="RightSidebar"></div>
    </div>
  );
};

export default OtherReceipt;
